import {
    Modal, ModalBody, ModalHeader,
} from 'reactstrap';
import cls from 'classnames';
import './index.scss';

export const Alert = ({
    toggle,
    isOpen = false,
    title = null,
    children,
    className = '',
    ...restProps
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <Modal
            toggle={toggle}
            isOpen={isOpen}
            container="body"
            trapFocus
            external
            backdropClassName="modal-form-backdrop"
            className={cls('modal-form modal-mobile-fullscreen', className)}
            {...restProps}
        >

            {Boolean(title) && (
                <ModalHeader toggle={toggle}>
                    {title}
                </ModalHeader>
            )}

            <ModalBody>
                {children}
            </ModalBody>
        </Modal>
    );
};